import React, { useState } from 'react';
import { PhoenixTitle } from './PhoenixTitle';
import { useGameStore } from '@/store/gameStore';
import { Button } from '@/components/ui/button';

export const TitleScreen: React.FC = () => {
  const [playAnimation, setPlayAnimation] = useState(false);
  const { setScreen } = useGameStore();

  const handleNewGame = () => {
    if (!playAnimation) {
      setPlayAnimation(true);
    }
  };

  const handleAnimationComplete = () => {
    setScreen('customize');
  };

  return (
    <div className="relative w-full h-screen bg-black overflow-hidden">
      <PhoenixTitle onAnimationComplete={handleAnimationComplete} playAnimation={playAnimation} />

      {!playAnimation && (
        <div className="absolute inset-0 flex flex-col items-center justify-end pb-20 pointer-events-none">
          <div className="pointer-events-auto space-y-4 w-full max-w-xs px-4">
            <Button
              onClick={handleNewGame}
              className="w-full py-3 text-lg font-bold bg-orange-600 hover:bg-orange-700 text-white rounded-lg"
            >
              New Game
            </Button>
            <Button
              disabled
              className="w-full py-3 text-lg font-bold bg-gray-700 text-gray-400 rounded-lg cursor-not-allowed"
            >
              Load Game
            </Button>
            <Button
              onClick={() => setScreen('settings')}
              className="w-full py-3 text-lg font-bold bg-gray-800 hover:bg-gray-700 text-white rounded-lg"
            >
              Settings
            </Button>
            <Button
              onClick={() => window.close()}
              className="w-full py-3 text-lg font-bold bg-red-900 hover:bg-red-800 text-white rounded-lg"
            >
              Exit
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};
